import { alpha, styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { forwardRef, memo } from 'react'
import { darkHoverBtnColor, lightHoverBtnColor } from '../theme/theme'
import { ListSubheader } from '@mui/material'
import { darkBg, white } from '../assets/colors'

export const ExtraWideTooltip = memo(styled(forwardRef(({ className, ...props }: TooltipProps, ref) => (
    <Tooltip {...props} ref={ref} classes={{ popper: className }} />
)))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 'none',
        padding: 0
    }
})))

export const NonInteractiveTooltip = memo(styled(forwardRef(({ className, ...props }: TooltipProps, ref) => (
    <Tooltip {...props} ref={ref} classes={{ popper: className }} disableInteractive />
)))(() => ({})))

export const InteractiveTooltip = memo(styled(forwardRef(({ className, maxHeight = "250px", ...props }: TooltipProps & { maxHeight?: string }, ref) => (
    <Tooltip {...props} ref={ref} />))
    )(({ maxHeight }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            maxHeight: maxHeight,
            overflowY: "auto",
        },
    }))
);

export const ExtraSmallButton = styled(Button)(() => ({
    minWidth: '24px',
    padding: '4px',
    height: '32px'
}))

export const UltraSmallButton = styled(Button)(() => ({
    minWidth: '24px',
    height: '24px !important',
    color: 'inherit',
    padding: 0
}))

export const ExtraSmallButtonHoverable = styled(Button)(({ theme }) => ({
    minWidth: '20px',
    border: 'none',
    backgroundColor: theme.palette.background.paper,
    '&:hover': {
        backgroundColor: alpha((theme.palette.mode === 'light') ? lightHoverBtnColor : darkHoverBtnColor, 0.8)
    },
    '&:active': {
        backgroundColor: alpha((theme.palette.mode === 'light') ? lightHoverBtnColor : darkHoverBtnColor, 0.8)
    }
}))

export const CustomListSubheader = styled(ListSubheader)(({ theme }) => ({
        lineHeight: '1',
        borderTop: 1,
        color: theme.palette.text.secondary,
        background: theme.palette.background.paper,
        borderColor: theme.palette.mode === 'dark' ? darkBg : white,
        fontSize: '12px',
        marginBottom: theme.spacing(1)
    }
))


